import { useEffect } from 'react';

// hook that updates local paymentCalculationDetails state object in NDS calculator when vehiclePaymentDetails are present
const useVehiclePaymentDetails = function (vehiclePaymentDetails, consumePersonalizedPayment, obfuscatedCredit, selectedLoanTerm, selectedLeaseTerm, vehicleCondition) {
  let showLenderName = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
  let activeTab = arguments.length > 7 ? arguments[7] : undefined;
  let hasTaxesFeesModalOpen = arguments.length > 8 ? arguments[8] : undefined;
  let term = selectedLoanTerm;
  let offerType = 'paymentOffers';
  switch (activeTab) {
    case 'lease':
      term = selectedLeaseTerm;
      offerType = 'leaseOffers';
      break;
    case 'cash':
      term = '-1';
      offerType = 'cashOffers';
      break;
  }
  const {
    offeredBy = '',
    payment = null,
    [vehicleCondition]: rate = '',
    cashAmount = null,
    pricingDetails = null
  } = vehiclePaymentDetails?.rates?.[obfuscatedCredit]?.[offerType]?.[term]?.[0] || {};
  useEffect(() => {
    if (payment && (offeredBy || !showLenderName) && typeof rate === 'number' && rate >= 0 || cashAmount || hasTaxesFeesModalOpen || pricingDetails) {
      consumePersonalizedPayment(true);
    } else {
      consumePersonalizedPayment(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [consumePersonalizedPayment, offeredBy, payment, rate, showLenderName, cashAmount]);
  return null;
};
export { useVehiclePaymentDetails as default };
